import { NotificationsService, Notification } from '@beeboard/common';
import { defineStore } from 'pinia';

type NotificationStoreState = {
  notifications: Notification[];
  isProjectRefreshRequired: boolean;
};
/**
 * #### Notification Store
 * Manages the state for user related (in-app) notifications and real-time updates.
 */
export const useNotificationStore = defineStore('notificationStore', {
  state: (): NotificationStoreState => ({
    notifications: [],
    isProjectRefreshRequired: false,
  }),

  actions: {
    async loadNotifications() {
      const notifications = await NotificationsService.getNotifications();
      this.notifications = notifications;
    },
    async markAllNotificationsAsRead() {
      await NotificationsService.markAllAsRead();
      this.notifications
        .filter((n) => !n.isRead)
        .forEach((n) => (n.isRead = true));
    },
    async markNotificationAsRead(id: string) {
      // Optimistic: flip local state first so the badge/styling react
      // immediately. If the request fails, roll back to the prior value and
      // re-throw so the caller's error toast still fires — this keeps the
      // dot/badge correct without waiting for the next loadNotifications.
      const notification = this.notifications.find((n) => n.id === id);
      const previousIsRead = notification?.isRead;
      if (notification) {
        notification.isRead = true;
      }
      try {
        await NotificationsService.markAsRead(id, { is_read: true });
      } catch (error) {
        if (notification && previousIsRead !== undefined) {
          notification.isRead = previousIsRead;
        }
        throw error;
      }
    },
  },
});
